import CobranzaRapipagoImportPage from "./CobranzaRapipagoImportPage";

export {CobranzaRapipagoImportPage}
export default CobranzaRapipagoImportPage
